import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Icon from '@material-ui/core/Icon';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  root: {
    cursor:'pointer',
    color:'#0033cc',
    margin:'0 3px',
    padding:'0 3px 3px',
    '&:hover':{
      borderRadius:4,
      border:'1px solid #0033cc'
    }
  },
  icon:{
      color:"#0033cc",
      fontSize:16
  }
}));

export default function EditActionIcon(props) {
  const {onClick} = props;
  const classes = useStyles();
  return (
    <span className={classes.root} onClick={onClick}>
        <EditIcon className={classes.icon} />
    </span>
  );
}